import React from 'react';

import { BaseFieldRenderer } from './base';
import { PrintReceiptBlock } from './printRows';

export class ReceiptFieldRenderer extends BaseFieldRenderer {
  render() {
    const {
      eventId,
      fieldValue,
      event: { queue, transaction },
    } = this.props;

    // Mute rendering of the receipt for events that have transaction and queue information
    // as this duplicates the receipt data for the purpose of dynamically rendering it
    if (queue || transaction || typeof fieldValue !== 'string') {
      return null;
    }

    if (this.props.variant === 'print') {
      return this.renderPrintReceipt(fieldValue);
    }

    const textLines = fieldValue.split(/\n/);
    return (
      <div
        className="receipt"
        id={`receipt-text-${eventId}`}
        onContextMenu={this.onContextMenu}
        style={this.style()}
      >
        {textLines.map((line, key) => {
          return (
            <div className="pre" key={`pre-${key}`}>
              {line.length === 0 ? ' ' : line}
            </div>
          );
        })}
      </div>
    );
  }

  renderPrintReceipt(text: string) {
    if (!text.trim()) {
      return null;
    }

    return (
      <div onContextMenu={this.onContextMenu}>
        <PrintReceiptBlock>{text.replace(/^\n+|\s+$/g, '')}</PrintReceiptBlock>
      </div>
    );
  }

  onContextMenu = (event: React.MouseEvent<HTMLElement, MouseEvent>) => {
    this.props.onContextMenu(event);
  };
}
